export default __webpack_public_path__ + "static/media/07__o_2.d899796e.jpg";